module.exports = __webpack_public_path__ + "images/5cd7097ea2992f137d10aa087fa81b5e.svg";